import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { MainShellComponent } from '@core/page/main-shell/main-shell.component';

export function mainShellDeactivateGuard(
  component: MainShellComponent,
  _current: ActivatedRouteSnapshot,
  _currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot
): boolean {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return true;

  if (component.analytics.isLoaded) {
    globalThis.location.href = nextState.url;
    return false;
  }

  return true;
}
